/** Use this object to access all env variables, rather than using `import.meta.env.*`. */

export const env = {
  VITE_AUTH0_EU_CLIENT_ID: import.meta.env.VITE_AUTH0_EU_CLIENT_ID,
  VITE_AUTH0_EU_DOMAIN: import.meta.env.VITE_AUTH0_EU_DOMAIN,
  VITE_WEBAPI_AUTH0_EU_AUDIENCE: import.meta.env.VITE_WEBAPI_AUTH0_EU_AUDIENCE,
  VITE_AUTH0_US_CLIENT_ID: import.meta.env.VITE_AUTH0_US_CLIENT_ID,
  VITE_AUTH0_US_DOMAIN: import.meta.env.VITE_AUTH0_US_DOMAIN,
  VITE_WEBAPI_AUTH0_US_AUDIENCE: import.meta.env.VITE_WEBAPI_AUTH0_US_AUDIENCE,

  /** Overrides from /public/env.js */
  // @ts-expect-error
  ...globalThis.env,
};
